import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import SignUpForm from '../../SharedComponents/SignUpForm/SingUpForm';
import RegistrationSteps from '../../RegistrationSteps';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import * as media from '../../../constants/mediaQueries';

const ProviderPageRightPart = (props) => {
  const { signup } = props.urls;
  const { selectedLocations, formAuthToken, formPostUrl } = props;

  return (
    <div>
      <div className="col-md-3">
        <div className="row">
          <MediaQuery minWidth={media.SCREEN_MD_MIN}>
            <div className="col-sm-6 col-md-12">
              {(selectedLocations.length > 0) && <OrderForm noScroll />}
            </div>
          </MediaQuery>
          <div className="col-sm-6 col-md-12">
            <SignUpForm signUpPath={formPostUrl} formAuthToken={formAuthToken} />
          </div>
          <div className="col-sm-6 col-md-12">
            <RegistrationSteps />
          </div>
        </div>
      </div>
    </div>
  );
};


ProviderPageRightPart.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  formAuthToken: PropTypes.string,
};
ProviderPageRightPart.defaultProps = {
  urls: {},
  selectedLocations: [],
  formAuthToken: '',
};
export default ProviderPageRightPart;
